import React from 'react';

import VersusDivider from '@/assets/icons/versusDivider';
import { Column } from '@/components/lib/components/Column';
import { Row } from '@/components/lib/components/Row';

type PlayerMatchupProps = {
    opponentColumn: React.ReactNode;
    userColumn: React.ReactNode;
};

export const PlayerMatchup = ({ opponentColumn, userColumn }: PlayerMatchupProps) => {
    return (
        <Row pt="s16" pb="s24" alignSelf="center">
            {userColumn}
            <Column width={48} justifyContent="center" alignItems="center">
                <VersusDivider />
            </Column>
            {opponentColumn}
        </Row>
    );
};
